(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-carousel"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('mm-home-carousel'))customElements.define('mm-home-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.index=0;this.slides=[...this.querySelectorAll('[data-slide]')];this.dots=[...this.querySelectorAll('[data-dot]')];
      this.querySelector('[data-next]')?.addEventListener('click',()=>this.show(this.index+1));
      this.querySelector('[data-previous]')?.addEventListener('click',()=>this.show(this.index-1));
      this.dots.forEach((dot,index)=>dot.addEventListener('click',()=>this.show(index)));
      this.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('[data-slide]');const index=this.slides.indexOf(slide);if(index>=0)this.show(index)});
      this.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();this.show(this.index+1)}if(event.key==='ArrowLeft'){event.preventDefault();this.show(this.index-1)}});
      this.addEventListener('touchstart',event=>{this.touchX=event.changedTouches[0].clientX},{passive:true});
      this.addEventListener('touchend',event=>{const delta=event.changedTouches[0].clientX-this.touchX;if(Math.abs(delta)>60)this.show(this.index+(delta<0?1:-1))},{passive:true});
    }
    show(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>slide.hidden=i!==this.index);this.dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===this.index)));const status=this.querySelector('[data-status]');if(status)status.textContent=this.dots[this.index]?.getAttribute('aria-label')||''}
  });

  } catch(e) { console.error(e); }
})();
})();
